module.exports = __webpack_public_path__ + "img/arrow-circle-broken-down-left.da82a25d.svg";